import { EventEmitter } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ActionInProgressInterface, BaseViewModelInterface, MessageInViewModelInterface, PropertyViewModelInterface, ViewModelEventDispatcherInterface } from '@nts/std/interfaces';

export class ViewModelEventDispatcher implements ViewModelEventDispatcherInterface {

  onActionInProgress: BehaviorSubject<boolean | ActionInProgressInterface> = new BehaviorSubject<boolean | ActionInProgressInterface>(false);
  onWingCollapsed: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  onValidationBarCollapsed: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  onNotificationBarCollapsed: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  onSnapShotSelected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  onMasterAreaSelected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  onNavigationPanelVisibilityChanged$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  onNavigationPanelCollapsed: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  onRefreshMessageInViewModel: Subject<MessageInViewModelInterface> = new Subject<MessageInViewModelInterface>();
  onAddMessageInViewModel: Subject<MessageInViewModelInterface> = new Subject<MessageInViewModelInterface>();
  onRemovedMessageInViewModel: Subject<BaseViewModelInterface> = new Subject<BaseViewModelInterface>();
  onClearMessagesInViewModel: Subject<BaseViewModelInterface> = new Subject<BaseViewModelInterface>();
  onClearAllMessages: Subject<void> = new Subject();
  externalViewModelFocused: EventEmitter<PropertyViewModelInterface> = new EventEmitter<PropertyViewModelInterface>();
  externalModalExecuted: EventEmitter<void> = new EventEmitter<void>();
  externalModalReturned: EventEmitter<void> = new EventEmitter<void>();
  onInitializing: Subject<void> = new Subject<void>();
  onMetaDataLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  beforeZoomOpen: Subject<void> = new Subject<void>();

  onDestroy(): void {

    // disabillitato destroy per evitare che si rompino i MS della versione REL_11_0_X, dalla versione successiva è abilitato
    return;

    this.onActionInProgress?.complete();
    this.onWingCollapsed?.complete();
    this.onValidationBarCollapsed?.complete();
    this.onNotificationBarCollapsed?.complete();
    this.onSnapShotSelected?.complete();
    this.onMasterAreaSelected?.complete();
    this.onNavigationPanelVisibilityChanged$?.complete();
    this.onNavigationPanelCollapsed?.complete();
    this.onRefreshMessageInViewModel?.complete();
    this.onAddMessageInViewModel?.complete();
    this.onRemovedMessageInViewModel?.complete();
    this.onClearMessagesInViewModel?.complete();
    this.onClearAllMessages?.complete();
    this.externalViewModelFocused?.complete();
    this.externalModalExecuted?.complete();
    this.externalModalReturned?.complete();
    this.onInitializing?.complete();
    this.onMetaDataLoaded?.complete();
    this.beforeZoomOpen?.complete();

    this.onActionInProgress = null;
    this.onWingCollapsed = null;
    this.onValidationBarCollapsed = null;
    this.onNotificationBarCollapsed = null;
    this.onSnapShotSelected = null;
    this.onMasterAreaSelected = null;
    this.onNavigationPanelVisibilityChanged$ = null;
    this.onNavigationPanelCollapsed = null;
    this.onRefreshMessageInViewModel = null;
    this.onAddMessageInViewModel = null;
    this.onRemovedMessageInViewModel = null;
    this.onClearMessagesInViewModel = null;
    this.onClearAllMessages = null;
    this.externalViewModelFocused = null;
    this.externalModalExecuted = null;
    this.externalModalReturned = null;
    this.onInitializing = null;
    this.onMetaDataLoaded = null;
    this.beforeZoomOpen = null;
  }
}
